import {
  Box,
  Button,
  createStyles,
  Divider,
  Flex,
  Grid,
  Modal,
  Radio,
  Skeleton,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import SkaiStarsSvg from "../../../../components/Svgs/SkaiStarsSvg";
import { useSelector } from "react-redux";
import {
  cancelAiSubscription,
  getSkaiTokenPackages,
  getSkaiTokenUsage,
  updateSkaiTokenPurchase,
} from "../../../../services/skaiTokens";
import { useMediaQuery } from "@mantine/hooks";
import { PaymentConfirmationModal } from "./PaymentConfirmationModal";
import { PaymentDetailsTable } from "./PaymentDetailsTable";
import { showError } from "../../../../utils";
import GreenTickMarkSvg from "../../../../components/Svgs/GreenTickMarkSvg";
import { SuccessModal } from "../../../../utils/SuccessModal";
import swal from "sweetalert";
import { IoMdInformationCircleOutline } from "react-icons/io";

const useStyles = createStyles((theme) => ({
  // allStaff: {
  //   fontFamily: "Inter",
  //   fontHeight: 600,
  //   fontSize: "16px",
  //   lineHeight: "24px",
  //   letterSpacing: "0%",
  //   textAlign: "left",
  //   color: "#000000",
  //   marginBlock: 20,
  //   marginInline: 5,
  // },
  content: {
    background: "#fff",
    borderRadius: "16px",
    padding: "1rem 2rem",
    marginBlock: 20,
  },
  contentContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 15,
    padding: "30px 0px",
  },
  textTitle: {
    Font: "Inter",
    fontWeight: 600,
    fontSize: 24,
    Color: "#000000",
  },
  textSubTitle: {
    Font: "Inter",
    fontWeight: 400,
    fontSize: 16,
    Color: "#000000",
  },
  tabContainer: {
    display: "flex",
    minWidth: "260px",
    padding: "6px 8px",
    borderRadius: "6px",
    border: "1px solid #E5E5E5",
    background: "#F5F5F5",
  },
  activeTab: {
    background: "#FFF",
    border: "1px solid #E5E5E5",
  },
  tab: {
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    padding: "8px 16px",
    background: "transparent",
    cursor: "pointer",
    "& p": {
      margin: "0",
      color: "#262626",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
    "& img": {
      width: "24px",
      marginRight: "5px",
    },
  },
  disableTab: {
    // cursor: "not-allowed",
    // opacity: "0.5",
  },
  footer: {
    background: "#F5F5F5",
    width: "100%",
    padding: "10px",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
  footerText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: "5px",
    color: "#979797",
    fontSize: "12px",
    fontWeight: 500,
    textAlign: "center",
    fontFamily: "Inter",
  },
  tableHeader: {
    backgroundColor: "#F5F5F5",
    fontSize: "12px",
    fontWeight: 500,
    textAlign: "center",
    fontFamily: "Inter",
  },
  modalBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    padding: "10px",
    width: "100%",
  },
  noticeTitle: {
    color: "#B75A26",
    fontSize: "12px",
    fontWeight: 500,
    textAlign: "center",
    fontFamily: "Inter",
    border: "1px solid #B75A26",
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "5px",
  },
  noticeBox: {
    backgroundColor: "#FFFAEB",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    padding: "5px",
    width: "fit-content",
  },
  gridCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
  },
  payNowBtn: {
    "& svg": {
      marginTop: 3,
      marginRight: 3,
    },
  },
}));
export const SkaiCreadits = () => {
  const { classes } = useStyles();
  const { profile } = useSelector((state) => state.profile);
  console.log("🚀 ~ SkaiCreadits ~ profile:", profile)
  const tokenPackages = useSelector((state) => state.skai.tokenPackages);
  const usageData = useSelector((state) => state.skai.usageHistory);
  const loading = useSelector((state) => state.skai.loading);
  const skaiCancelLoading = useSelector(
    (state) => state.skai.skaiCancelLoading
  );
  const [selectedTab, setSelectedTab] = useState("onetime-purchase");
  const [selectedPackage, setSelectedPackage] = useState(
    "68346643d1cd7515c5adbb28"
  );

  const MobileScreen = useMediaQuery("(max-width: 768px)");
  const [customModalOpen, setCustomModalOpen] = useState(false);
  const [customCredits, setCustomCredits] = useState("");
  const [customPrice, setCustomPrice] = useState("");
  const [creditError, setCreditError] = useState("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccessModal] = useState(false);

  useEffect(() => {
    getSkaiTokenPackages(true);
  }, []);

  useEffect(() => {
    getSkaiTokenUsage(profile?.user?.admin || profile?.user?.id);
  }, [profile?.user]);

  // Filter packages based on selectedTab
  const filteredPackages = tokenPackages?.filter((pkg) => {
    if (selectedTab === "onetime-purchase") {
      return pkg.plan === "standard" || pkg.plan === "basic";
    } else if (selectedTab === "monthly-subscription") {
      return pkg.plan === "custom";
    }
    return true;
  });
  console.log("🚀 ~ SkaiCreadits ~ filteredPackages:", filteredPackages)

  const selectedFilteredPackage = filteredPackages?.find(
    (pkg) => pkg.plan === "custom"
  )?.plan;

  const usageArray = Array.isArray(usageData) ? usageData : [];
  const existingRecord = usageArray.find(
    (item) =>
      item?.admin === profile?.user?.admin || item?.admin === profile?.user?.id
  );
  console.log("🚀 ~ SkaiCreadits ~ existingRecord:", existingRecord)

  useEffect(() => {
    setSelectedPackage(
      !existingRecord?.aiPackageId
        ? filteredPackages[0]?._id
        : existingRecord?.aiPackageId
    );
    // setSelectedPackage(filteredPackages[0]?._id);
  }, [selectedTab]);

  useEffect(() => {
    setSelectedTab(existingRecord?.planType === "free-drop" ? "onetime-purchase" : existingRecord?.planType);
    // setSelectedPackage("68346643d1cd7515c5adbb28");
  }, [existingRecord]);

  const skeletonCount = selectedTab === "onetime-purchase" ? 2 : 1;

  const handlePayment = async () => {
    try {
      const payload = {
        plan: selectedPackage,
        planType: selectedTab,
      };
      if(profile?.subscription?.packageId?.name === "Free" ){
        showError("You are on Free plan. Please upgrade your plan to access Skai Credits.");
        return;
      }

      let response = await updateSkaiTokenPurchase(
        existingRecord?._id,
        payload,
        profile?.user?.admin || profile?.user?.id
      );
      if (response.status === 200) {
        setConfirmModalOpen(false);
        await getSkaiTokenUsage(profile?.user?.admin || profile?.user?.id);
        setPaymentSuccessModal(true);
      }
    } catch (error) {
      setConfirmModalOpen(false);
      console.error("Payment error:", error);
      showError(error?.response?.data?.message || "Payment failed");
    }
  };

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  const handleCloseCustomModal = () => {
    setCustomModalOpen(false);
    setCustomPrice("");
    setCustomCredits("");
    setCreditError("");
  };

  const handleCloseConfirmModal = () => {
    setConfirmModalOpen(false);
    setCustomPrice("");
    setCustomCredits("");
    setCreditError("");
  };

  const handleCloseSuccessModal = () => {
    setPaymentSuccessModal(false);
  };

  const handleCancelSubscription = async (data) => {
    const res = await cancelAiSubscription(data);
    if (res?.status === 200) {
      await getSkaiTokenUsage(profile?.user?.admin || profile?.user?.id);
      swal({
        title: "Success",
        text: `${res?.data?.message}`,
        icon: "success",
        button: "Ok",
      });
    }
    setSelectedPackage(filteredPackages[0]?._id);
  };

  return (
    <>
      {/* <Text className={classes.allStaff}>All Staff</Text> */}
      <Box className={classes.content}>
        <Flex justify="flex-end" mt={"1rem"} gap={".5rem"}>
          <Text ff={"inter"} fw={500} fz={"lg"}>
            Credit Balance:{" "}
          </Text>
          {loading ? (
            <Skeleton radius="md" height="30px" width="50px" />
          ) : (
            <Text ff={"inter"} fw={500} fz={"lg"}>
              {/* {existingRecord?.active && existingRecord?.paid */}
              {existingRecord?.planType === "monthly-subscription"
                ? "Unlimited"
                : Number(existingRecord?.adminTotalTokens)}
            </Text>
          )}
        </Flex>
        <Box px={20} className={classes.contentContainer}>
          <SkaiStarsSvg />
          <Text className={classes.textTitle}>
            Boost staff efficiency with Skai Ai
          </Text>
          <Text className={classes.textSubTitle}>
            Skai helps your staff write complaint notes faster and more
            accurately.
          </Text>
          <Box className={classes.tabContainer}>
            <Box
              className={`${classes.tab} ${
                loading
                  ? `${classes.disableTab}`
                  : `${
                      selectedTab === "onetime-purchase"
                        ? classes.activeTab
                        : ""
                    }`
              }`}
              onClick={() => handleTabChange("onetime-purchase")}
            >
              <Text fw={500}>One-Time purchase</Text>
            </Box>
            <Box
              id="medication-week"
              className={`${classes.tab} ${
                loading
                  ? `${classes.disableTab}`
                  : `${
                      selectedTab === "monthly-subscription"
                        ? classes.activeTab
                        : ""
                    }`
              }`}
              onClick={() => handleTabChange("monthly-subscription")}
            >
              <Text fw={500} className={classes.disableTab}>
                Add to monthly subscription
              </Text>
            </Box>
          </Box>
          <Box>
            {loading ? (
              <Grid mt="md" gutter="lg" columns={12}>
                {[...Array(skeletonCount)].map((_, index) => (
                  <Grid.Col key={index} span={MobileScreen ? 12 : 6}>
                    <Skeleton height={"200px"} width="400px" radius="md" />
                  </Grid.Col>
                ))}
              </Grid>
            ) : (
              <Radio.Group
                value={selectedPackage}
                onChange={setSelectedPackage}
              >
                <Grid mt="md" gutter="lg" columns={12} justify="center">
                  {filteredPackages?.map((pkg, index) => {
                    return (
                      <Grid.Col
                        key={pkg._id}
                        span={MobileScreen ? 12 : 6}
                        className={classes.gridCol}
                      >
                        <Box
                          onClick={() => {
                            setSelectedPackage(pkg?._id);
                          }}
                          w={
                            selectedFilteredPackage === "custom"
                              ? "800px"
                              : "400px"
                          }
                          style={{
                            cursor: "pointer",
                            borderRadius: "10px",
                            transition: "all 0.3s ease",
                            height: "200px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            border:
                              selectedPackage === pkg?._id
                                ? "2px solid #FFAF4A"
                                : "1px solid #ccc",
                            boxShadow:
                              selectedPackage === pkg?._id
                                ? "rgba(253, 197, 29, 0.3) 0px 0px 0px 10px"
                                : "none",
                            "@media (max-width:600px)": {
                              maxWidth: "300px",
                            },
                          }}
                        >
                          <Box>
                            <Flex
                              align="center"
                              justify="space-between"
                              pt={10}
                              px={10}
                            >
                              <Text
                                fw={400}
                                size="14"
                                ff={"Inter"}
                                c={"#979797"}
                              >
                                {index === 2 ? "Custom Credits" : "Credits"}
                              </Text>
                              <Radio
                                color="yellow"
                                variant="outline"
                                value={pkg._id}
                                checked={selectedPackage === pkg._id}
                                onChange={() => setSelectedPackage(pkg._id)}
                              />
                            </Flex>
                            <Text
                              fw={700}
                              size="30px"
                              ff={"Inter"}
                              c={"#262626"}
                              pt={10}
                              pl={10}
                            >
                              {pkg?.tokens === "unlimited"
                                ? "Unlimited Credits"
                                : pkg?.tokens}
                            </Text>
                          </Box>
                          <Box className={classes.footer}>
                            <Text
                              fw={600}
                              size="16"
                              ff={"Inter"}
                              c={"#979797"}
                              mt="auto"
                              className={classes.footerText}
                            >
                              Purchase credit for{" "}
                              <Text fw={600} size="16" ff={"Inter"} c={"#000"}>
                                ${pkg?.price}
                              </Text>
                            </Text>
                          </Box>
                        </Box>
                      </Grid.Col>
                    );
                  })}
                </Grid>
              </Radio.Group>
            )}
          </Box>
        </Box>
        <Divider mt={40} />

        <Box mt="xl" w="100%">
          <Text fw={600} size="20" mb="sm">
            Payment Details
          </Text>
          <PaymentDetailsTable
            selectedTab={selectedTab}
            tokenPackages={tokenPackages}
            selectedPackage={selectedPackage}
            // customCredits={customCredits}
            // customPrice={customPrice}
            classes={classes}
          />
        </Box>
        <Flex justify="flex-end" mt="xl" gap="md">
          {/* {existingRecord?.active  && existingRecord?.paid && ( */}
          {existingRecord?.planType === "monthly-subscription" && (
            <Button
              onClick={() =>
                handleCancelSubscription({
                  _id: existingRecord?._id,
                  stripeSubscriptionId: existingRecord?.stripeSubscriptionId,
                })
              }
              loading={skaiCancelLoading}
              disabled={false}
              radius="md"
              size="md"
              variant="filled"
              color="red"
              c={"#fff"}
              w={200}
            >
              Cancel Subscription
            </Button>
          )}
          <Tooltip
            position="top"
            label="Select the Package!"
            display={
              selectedTab !== "monthly-subscription"
                ? "none"
                : selectedTab == "monthly-subscription" &&
                  (existingRecord?.aiPackageId !== selectedPackage ||
                    (existingRecord?.planType == "monthly-subscription" &&
                      existingRecord?.active))
                ? "none"
                : undefined
            }
          >
            <span>
              <Button
                onClick={() => setConfirmModalOpen(true)}
                loading={loading}
                disabled={
                  loading || existingRecord?.planType == "monthly-subscription"
                    ? existingRecord?.active
                    : selectedTab == "monthly-subscription" &&
                      existingRecord?.aiPackageId === selectedPackage
                    ? true
                    : false
                }
                // disabled={loading}
                radius="md"
                className={classes.payNowBtn}
                size="md"
                variant="filled"
                color="yellow"
                c={"#000"}
                w={200}
              >
                {selectedTab == "monthly-subscription" &&
                existingRecord?.planType !== "monthly-subscription" &&
                existingRecord?.aiPackageId === selectedPackage ? (
                  <IoMdInformationCircleOutline size={20} />
                ) : null}{" "}
                Pay Now
              </Button>
            </span>
          </Tooltip>
        </Flex>
      </Box>
      {/* Payment Confirmation Modal */}
      <PaymentConfirmationModal
        opened={confirmModalOpen}
        onClose={handleCloseConfirmModal}
        onConfirm={async () => {
          setConfirmModalOpen(false);
          await handlePayment();
        }}
        // amount={customPrice || selectedPackagePrice}
        tokenPackages={tokenPackages}
        selectedPackage={selectedPackage}
        selectedTab={selectedTab}
      />
      {/* Payment Success Modal */}
      <SuccessModal
        opened={paymentSuccess}
        onClose={handleCloseSuccessModal}
        icon={<GreenTickMarkSvg width={48} height={48} />}
        title="Success!"
        message="Your payment has been successfully processed. You can now begin using your subscription."
        buttonText="OK"
      />

      {/* Custom Credit Count Modal */}
      <Modal
        opened={customModalOpen}
        onClose={() => handleCloseCustomModal()}
        title="Custom Credit"
        overlayProps={{ opacity: 0.55, blur: 3 }}
        centered
        size="md"
        radius="lg"
        zIndex={1000}
        transitionProps={{ duration: 200 }}
      >
        <Box className={classes.modalBox}>
          <Box className={classes.noticeBox}>
            <Box className={classes.noticeTitle}>Notice</Box>
            <Text size="sm" color="#B75A26" ff={"Inter"}>
              A minimum of 2,000 credits is required.
            </Text>
          </Box>
          <TextInput
            label="Credit Amount"
            placeholder="Enter Credit Amount"
            type="number"
            radius={"md"}
            size="md"
            w={"100%"}
            value={customCredits}
            onChange={(e) => {
              const value = e.currentTarget.value;
              setCustomCredits(value);

              const creditNumber = parseInt(value, 10);
              if (!isNaN(creditNumber)) {
                const calculatedPrice = (creditNumber * 0.0085).toFixed(2);
                setCustomPrice(calculatedPrice);
              } else {
                setCustomPrice("");
              }
            }}
          />
          <TextInput
            label="Amount"
            placeholder="Amount"
            type="number"
            radius={"md"}
            w={"100%"}
            size="md"
            value={customPrice}
            readOnly
            onChange={(e) => setCustomPrice(e.currentTarget.value)}
          />
          {creditError && (
            <Text size="sm" color="red" ff={"Inter"}>
              Please add at least 2,000 credits to continue
            </Text>
          )}
        </Box>
        <Flex justify="flex-end">
          <Button
            onClick={() => {
              const creditNumber = parseInt(customCredits, 10);
              if (creditNumber < 2000) {
                setCreditError(true);
              } else {
                setCreditError(false);
                setCustomModalOpen(false);
              }
            }}
            color="yellow"
            radius="md"
            size="md"
            variant="filled"
            c={"#000"}
            w={100}
          >
            Add
          </Button>
        </Flex>
      </Modal>
    </>
  );
};
